import React, {useEffect, useState} from 'react';
import axios from 'axios';
import Swal from 'sweetalert2';
import {baseUrl, ipAddress, userLocation, userName} from '../Univ.js';
const PurchaseOrderCreate = () => {
    const [quotations, setQuotations] = useState([]);
    const [selectedQuotation, setSelectedQuotation] = useState(null);
    const [items, setItems] = useState([]);
    const [poNo, setPoNo] = useState('');
    useEffect(() => {
        fetchQuotations();
    }, []);
    const fetchQuotations = () => {
        axios.get(`${baseUrl}vendor-quotation/`)
            .then(res => {
                setQuotations(res.data);
            })
            .catch(console.log);
    };
    const loadQuotation = async (id) => {
        if (!id) return;
        try {
            const qRes = await axios.get(`${baseUrl}vendor-quotation/${id}/`);
            const iRes = await axios.get(`${baseUrl}vendor-quotation-item/`);
            const quotation = qRes.data;
            const filteredItems = iRes.data.filter(
                x => x.quotation?.id == id
            );
            setSelectedQuotation(quotation);
            setItems(filteredItems);
        } catch (err) {
            console.log(err);
            Swal.fire('Error', 'Failed to load quotation', 'error');
        }
    };
    const generatePO = (e) => {
        e.preventDefault();
        if (!selectedQuotation) {
            Swal.fire(
                'Error',
                'Select Quotation',
                'error'
            );
            return;
        }
        if (!poNo) {
            Swal.fire(
                'Error',
                'Enter PO Number',
                'error'
            );
            return;
        }
        const formData = new FormData();
        formData.append(
            'quotation_id',
            selectedQuotation.id
        );
        formData.append(
            'po_no',
            poNo
        );
        formData.append(
            'addedby',
            userName
        );
        formData.append(
            'location',
            userLocation
        );
        formData.append(
            'ip_add',
            ipAddress
        );
        axios.post(
            `${baseUrl}po-create/`,
            formData
        )
            .then(response => {
                Swal.fire({
                    title: 'Success',
                    text: 'Purchase Order Created Successfully',
                    icon: 'success',
                    timer: 2000,
                    showConfirmButton: false
                });
                setTimeout(() => {
                    window.location.reload();
                }, 2000);
            })
            .catch(error => {
                console.log(error.response?.data);
                Swal.fire(
                    'Error',
                    'Failed To Create Purchase Order',
                    'error'
                );
            });
    };
    return (
        <section className="container mt-4">

            <h3 className="text-center mb-3">
                Purchase Order Creation
            </h3>

            <div className="row">

                <div className="col-md-4">
                    <label>Select Quotation</label>

                    <select
                        className="form-control"
                        onChange={(e) => loadQuotation(e.target.value)}
                    >
                        <option value="">Select</option>

                        {quotations.map(q => (
                            <option key={q.id} value={q.id}>
                                {q.quotation_no} - {q.vendor?.name}
                            </option>
                        ))}
                    </select>
                </div>

                <div className="col-md-4">
                    <label>PO No</label>
                    <input
                        className="form-control"
                        value={poNo}
                        onChange={(e) => setPoNo(e.target.value)}
                    />
                </div>

            </div>

            {/* HEADER INFO */}
            {selectedQuotation && (
                <div className="mt-4">

                    <div className="alert alert-info">
                        <b>Vendor:</b> {selectedQuotation.vendor?.name} <br/>
                        <b>RFQ:</b> {selectedQuotation.rfq?.rfq_no} <br/>
                        <b>Total:</b> ₹{selectedQuotation.total_amount}
                    </div>

                    {/* ITEMS TABLE */}
                    <div className="table-responsive">

                        <table className="erp-table-modern">

                            <thead>
                            <tr style={{backgroundColor: '#1bc5ce', color: 'white'}}>
                                <th>Product</th>
                                <th>Qty</th>
                                <th>Rate</th>
                                <th>GST</th>
                                <th>Net Amount</th>
                            </tr>
                            </thead>

                            <tbody>

                            {items.length > 0 ? (
                                items.map((item, i) => (
                                    <tr key={i}>
                                        <td>{item.product}</td>
                                        <td>{item.qty}</td>
                                        <td>₹{item.rate}</td>
                                        <td>{item.gst}%</td>
                                        <td>₹{item.net_amount}</td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan="5" className="text-center text-danger">
                                        No Items Found
                                    </td>
                                </tr>
                            )}

                            </tbody>

                        </table>

                    </div>

                </div>
            )}

            <button
                className="btn btn-primary mt-3"
                onClick={generatePO}
            >
                Generate PO
            </button>

        </section>
    );
};
export default PurchaseOrderCreate;